// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.cultivation_type_enum */
var CultivationTypeEnum;
(function (CultivationTypeEnum) {
    CultivationTypeEnum["batch"] = "batch";
    CultivationTypeEnum["fed-batch"] = "fed-batch";
    CultivationTypeEnum["repeated fed-batch"] = "repeated fed-batch";
    CultivationTypeEnum["continuous"] = "continuous";
})(CultivationTypeEnum || (CultivationTypeEnum = {}));
;
export default CultivationTypeEnum;
/** Zod schema for cultivation_type_enum */
export const cultivationTypeEnum = z.nativeEnum(CultivationTypeEnum);
//# sourceMappingURL=CultivationTypeEnum.js.map